import CategoryIcon from '@material-ui/icons/Bookmark';

import CategoryList from './CategoryList';
import CategoryEdit from './CategoryEdit';

export default {
    list: CategoryList,
    edit: CategoryEdit,
    icon: CategoryIcon,
};
